import React, { useEffect, useState } from 'react';
import './App.css';

const APP_STORE_URL =
  'https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share';

function isIOS(): boolean {
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  if (
    navigator.platform === 'MacIntel' &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1
  ) {
    return true;
  }
  return false;
}

function isAndroid(): boolean {
  return /android/i.test(navigator.userAgent || '');
}

const Download: React.FC = () => {
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    document.title = 'Tải app Fconnect';
    if (isIOS()) {
      window.location.replace(APP_STORE_URL);
      return;
    }
    if (isAndroid()) {
      window.location.replace(PLAY_STORE_URL);
      return;
    }
    setShowFallback(true);
  }, []);

  if (showFallback) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" style={{ textAlign: 'center', maxWidth: 420 }}>
          <p style={{ margin: '0 0 1.25rem', color: '#333' }}>
            Truy cập từ máy tính — vui lòng mở liên kết trên điện thoại hoặc chọn cửa hàng:
          </p>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem',
              alignItems: 'stretch',
            }}
          >
            <a
              href={APP_STORE_URL}
              rel="noopener noreferrer"
              style={{ color: '#007aff', fontWeight: 600 }}
            >
              Tải trên App Store (iOS)
            </a>
            <a
              href={PLAY_STORE_URL}
              rel="noopener noreferrer"
              style={{ color: '#01875f', fontWeight: 600 }}
            >
              Tải trên Google Play (Android)
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="loading-container">
      <div className="loading-spinner">Đang chuyển đến cửa hàng ứng dụng…</div>
    </div>
  );
};

export default Download;
